import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";
import "./NavBar.css";

const navItems = [
  { title: "Home", path: "home" },
  { title: "About", path: "about" },
  { title: "Skills", path: "skills" },
  { title: "Resume", path: "resume" },
  { title: "Portfolio", path: "portfolio" },
  { title: "Contact Me", path: "contact" },
];

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="navbar">
      <div className="logo">
        <Link to="home" spy={true} smooth={true} offset={-70} duration={500}>
          <img src={process.env.PUBLIC_URL + "/logo.png"} alt="logo" />
        </Link>
      </div>
      <div className="nav-menu">
        <div className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
        <div className={`menu-list ${menuOpen ? "open" : ""}`}>
          {navItems.map((item, index) => (
            <Link
              key={index}
              className="menu-item"
              to={item.path}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              onClick={toggleMenu}
              activeClass="active"
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NavBar;
